export default "__VITE_ASSET__d1328f80__"